import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  BaseHierarchicalCrudComponent,
  CrudPage,
  GenericForm,
  ICrudService,
} from '@zendra/shared';
import {
  OtherUseByConservationTypeCreateDto,
  OtherUseByConservationTypeUpdateDto,
} from '../proxy/geographic/dtos/other-use-by-conservation-type';
import { OtherUseByConservationTypeService } from '../proxy/geographic/controllers';
import { OtherUseByConservationTypeProjectionPlanningOrchestratorService } from 'orchestrator';
import {
  GetOtherUseByConservationTypeProjectionListInputDto,
  OtherUseByConservationTypeProjectionDto,
  OtherUseByConservationTypeProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/other-use-by-conservation-types/models';
import {
  OTHERUSEBYCONSERVATIONTYPE_CONFIG,
  OTHERUSEBYCONSERVATIONTYPE_FIELDS,
} from './other-use-by-conservation-type.config';

@Component({
  selector: 'app-other-use-by-conservation-type',
  imports: [CardComponent, CardBodyComponent, CrudPage, GenericForm],
  providers: [ListService, OtherUseByConservationTypeService, ConfirmationService],
  templateUrl: './other-use-by-conservation-type.html',
  styleUrl: './other-use-by-conservation-type.scss',
})
export class OtherUseByConservationType extends BaseHierarchicalCrudComponent<
  OtherUseByConservationTypeProjectionDto,
  OtherUseByConservationTypeCreateDto,
  OtherUseByConservationTypeUpdateDto,
  OtherUseByConservationTypeProjectionExcelDownloadDto
> {
  private readonly geographicService = inject(OtherUseByConservationTypeService);
  private readonly orchestratorService = inject(
    OtherUseByConservationTypeProjectionPlanningOrchestratorService,
  );

  service: ICrudService<
    OtherUseByConservationTypeProjectionDto,
    OtherUseByConservationTypeCreateDto,
    OtherUseByConservationTypeUpdateDto,
    OtherUseByConservationTypeProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'otherUseByConservationTypeId',
    ),
    getList: (query: GetOtherUseByConservationTypeProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
  };

  config = OTHERUSEBYCONSERVATIONTYPE_CONFIG;
  fields = OTHERUSEBYCONSERVATIONTYPE_FIELDS;

  protected prepareUpdateDto(
    data: any,
    selected: OtherUseByConservationTypeProjectionDto,
  ): OtherUseByConservationTypeUpdateDto {
    return {
      hectare: data.hectare,
      otherUseId: data.otherUseId,
      registerLocationId: data.registerLocationId,
      conservationTypeId: data.conservationTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OtherUseByConservationType';
  }
}
